"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPatientEtId = createPatientEtId;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
function createPatientEtId(_intl, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.patientEtId);
    if (event === undefined) {
        return { value: "-" };
    }
    return {
        value: event.value,
        timestamp: event.timestamp,
        origin: event.origin
    };
}
